import { combineReducers } from "redux";
import aboutus from "../features/admin/aboutus/aboutus/Slice";
import signatureskills from "../features/admin/aboutus/signatureskills/Slice";
import visionandmissions from "../features/admin/aboutus/visionandmissions/Slice";
import ourvictories from "../features/admin/aboutus/ourvictory/Slice";
import ourachievement from "../features/admin/aboutus/ourachievement/Slice";



const Aboutus = combineReducers({

  aboutus:aboutus,
  signatureskills:signatureskills,
  visionandmissions:visionandmissions,
  ourvictories:ourvictories,
  ourachievement:ourachievement,
  
});


export default Aboutus;
